import { NewdanhmuckhohangService } from 'src/services/newdanhmuckhohang.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const NEWDANHMUCKHOHANG_NEW_CARE_SUCCESS = 'NEWDANHMUCKHOHANG:NEW_CARE_SUCCESS'
export const NEWDANHMUCKHOHANG_LIST_SUCCESS = 'NEWDANHMUCKHOHANG:FIND_ALL_SUCCESS'
export const NEWDANHMUCKHOHANG_LIST_FAILD = 'NEWDANHMUCKHOHANG:FIND_ALL_FAILD'
export const NEWDANHMUCKHOHANG_COUNT_ASSIGN_SUCCESS = 'NEWDANHMUCKHOHANG:COUNT_ASSIGN_SUCCESS'
export const NEWDANHMUCKHOHANG_COUNT_ASSIGN_FAILD = 'NEWDANHMUCKHOHANG:COUNT_ASSIGN_FAILD'

export const NEWDANHMUCKHOHANG_CREATE_SUCCESS = 'NEWDANHMUCKHOHANG:CREATE_SUCCESS'
export const NEWDANHMUCKHOHANG_CREATE_FAILD = 'NEWDANHMUCKHOHANG:CREATE_FAILD'

export const NEWDANHMUCKHOHANG_IMPORT_SUCCESS = 'NEWDANHMUCKHOHANG:IMPORT_SUCCESS'
export const NEWDANHMUCKHOHANG_SAVE_SUCCESS = 'NEWDANHMUCKHOHANG:SAVE_SUCCESS'
export const NEWDANHMUCKHOHANG_SAVE_FAILD = 'NEWDANHMUCKHOHANG:SAVE_SUCCESS'

export const NEWDANHMUCKHOHANG_DEL_SUCCESS = 'NEWDANHMUCKHOHANG:DEL_SUCCESS'
export const NEWDANHMUCKHOHANG_DEL_FAILD = 'NEWDANHMUCKHOHANG:DEL_FAILD'

export const NEWDANHMUCKHOHANG_ONE_SUCCESS = 'NEWDANHMUCKHOHANG:FIND_ONE_SUCCESS'
export const NEWDANHMUCKHOHANG_ONE_FAILD = 'NEWDANHMUCKHOHANG:FIND_ONE_FAILD'

export const NEWDANHMUCKHOHANG_HISTORY_LIST_SUCCESS = 'NEWDANHMUCKHOHANG:HISTORY_FIND_ALL_SUCCESS'
export const NEWDANHMUCKHOHANG_HISTORY_LIST_FAILD = 'NEWDANHMUCKHOHANG:HISTORY_FIND_ALL_FAILD'

export const NEWDANHMUCKHOHANG_UPDATE_FILTER = 'NEWDANHMUCKHOHANG:NEWDANHMUCKHOHANG_UPDATE_FILTER'

export const NEWDANHMUCKHOHANG_LIST_EXPORT_SUCCESS = 'NEWDANHMUCKHOHANG:FIND_ALL_EXPORT_SUCCESS'
export const NEWDANHMUCKHOHANG_LIST_EXPORT_FAILD = 'NEWDANHMUCKHOHANG:FIND_ALL_EXPORT_FAILD'

export const NEWDANHMUCKHOHANG_UPDATE_HOMEPAGE_FILTER = 'NEWDANHMUCKHOHANG:NEWDANHMUCKHOHANG_UPDATE_HOMEPAGE_FILTER'

export const NEWDANHMUCKHOHANG_HOMEPAGE_LIST_SUCCESS = 'NEWDANHMUCKHOHANG:FIND_HOMEPAGE_LIST_SUCCESS'
export const NEWDANHMUCKHOHANG_HOMEPAGE_LIST_FAILD = 'NEWDANHMUCKHOHANG:FIND_HOMEPAGE_LIST_FAILD'

export const NEWDANHMUCKHOHANG_HOMEPAGE_ONE_SUCCESS = 'NEWDANHMUCKHOHANG:FIND_HOMEPAGE_ONE_SUCCESS'
export const NEWDANHMUCKHOHANG_HOMEPAGE_ONE_FAILD = 'NEWDANHMUCKHOHANG:FIND_HOMEPAGE_ONE_FAILD'

export const NEWDANHMUCKHOHANG_ORDER_SUCCESS = 'NEWDANHMUCKHOHANG:ORDER_SUCCESS'
export const NEWDANHMUCKHOHANG_ORDER_FAILD = 'NEWDANHMUCKHOHANG:ORDER_FAILD'

export const NEWDANHMUCKHOHANG_GET_SIM_ANALYSIS_SUCCESS = 'NEWDANHMUCKHOHANG:GET_SIM_ANALYSIS_SUCCESS'
export const NEWDANHMUCKHOHANG_GET_SIM_ANALYSIS_FAILD = 'NEWDANHMUCKHOHANG:GET_SIM_ANALYSIS_FAILD'

export const NEWDANHMUCKHOHANG_HANDLE_IMPORT_ERRORS = 'NEWDANHMUCKHOHANG:NEWDANHMUCKHOHANG_HANDLE_IMPORT_ERRORS'

export const NewdanhmuckhohangAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
    homepageList,
    updateHomepageFilter,
    homepageFindOne,
    sendOrder,
    getSimAnalysis,
    khohangList,
}

function khohangList() {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmuckhohangService.khohangList()
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function getSimAnalysis(number) {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            // dispatch(AppAction.appLoading(true));
            NewdanhmuckhohangService.getSimAnalysis(number).then((response) => {
                dispatch(success(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                // dispatch(AppAction.appLoading(false));
            })
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_GET_SIM_ANALYSIS_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_GET_SIM_ANALYSIS_FAILD, error } }
}

function updateHomepageFilter(payload) {
    return { type: NEWDANHMUCKHOHANG_UPDATE_HOMEPAGE_FILTER, data: payload }
}

function homepageList() {
    return (dispatch, getState) => {
        const { newdanhmuckhohang } = getState();
        dispatch(AppAction.appLoading(true));

        const { homepageNewdanhmuckhohangFilter } = newdanhmuckhohang;
        const homepageNewdanhmuckhohangPage = homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangPage;
        const homepageNewdanhmuckhohangLimit = homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangLimit;

        return new Promise((resolve, reject) => {
            NewdanhmuckhohangService.homepageList(homepageNewdanhmuckhohangFilter).then((rs) => {
                if (!!homepageNewdanhmuckhohangFilter && homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangPage === 0) {
                    dispatch(success({
                        homepageNewdanhmuckhohangItems: rs.data.values,
                        homepageNewdanhmuckhohangTotal: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmuckhohang.homepageNewdanhmuckhohangItems;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = homepageNewdanhmuckhohangLimit * homepageNewdanhmuckhohangPage; i < homepageNewdanhmuckhohangLimit * homepageNewdanhmuckhohangPage + homepageNewdanhmuckhohangLimit; i++) {
                        if (typeof rsDataValues[i - homepageNewdanhmuckhohangLimit * homepageNewdanhmuckhohangPage] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - homepageNewdanhmuckhohangLimit * homepageNewdanhmuckhohangPage];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        homepageNewdanhmuckhohangItems: uniqueItems,
                        homepageNewdanhmuckhohangTotal: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_HOMEPAGE_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_HOMEPAGE_LIST_FAILD, error } }
}

function homepageFindOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.homepageFindOne(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_HOMEPAGE_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_HOMEPAGE_ONE_FAILD, error } }
}

function updateFilter(payload) {
    return { type: NEWDANHMUCKHOHANG_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      NewdanhmuckhohangService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { newdanhmuckhohang } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmuckhohang.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0;
        let errorRows = {};
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmuckhohangService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                // if (count === payload.length) {
                //     dispatch(success(rs));
                //     dispatch(AppAction.appLoading(false));
                // }

                if (rs.data.errorRows) {
                    Object.entries(rs.data.errorRows).forEach(([key, value]) => {
                        errorRows[i * 200 + Number(key)] = value;
                    });
                }

                if (i + 200 >= payload.length) {
                    dispatch(handleErrors(errorRows));
                    dispatch(success(rs));
                    dispatch(NewdanhmuckhohangAction.list());
                    alert("Tải file thành công: \"" + payload[0].ten_file_upload + "\" (" + count + " bản ghi)");
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function handleErrors(data) { return { type: NEWDANHMUCKHOHANG_HANDLE_IMPORT_ERRORS, data } }
    function success(data) { return { type: NEWDANHMUCKHOHANG_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            NewdanhmuckhohangService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { newdanhmuckhohang } = getState();

            const { filter } = newdanhmuckhohang;

            // Perform your asynchronous operation (e.g., API call)
            NewdanhmuckhohangService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: NEWDANHMUCKHOHANG_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { newdanhmuckhohang } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = newdanhmuckhohang;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            NewdanhmuckhohangService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = newdanhmuckhohang.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: NEWDANHMUCKHOHANG_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            NewdanhmuckhohangService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(NewdanhmuckhohangAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: NEWDANHMUCKHOHANG_SAVE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_SAVE_FAILD, error } }
}

function create(payload, creatingFromAway = false) {
    return dispatch => {
        if (!creatingFromAway) dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.create(payload).then((rs) => {
            dispatch(success(rs));
            if (!creatingFromAway) dispatch(NewdanhmuckhohangAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể tạo, có thể do trùng mã!");
        }).finally(() => {
            if (!creatingFromAway) dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmuckhohangAction.list())
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể cập nhật, có thể do trùng mã!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_CREATE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(NewdanhmuckhohangAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_DEL_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_ONE_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(NewdanhmuckhohangAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}

function history(payload) {
    return (dispatch, getState) => {
        const { newdanhmuckhohang } = getState()
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...newdanhmuckhohang.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_HISTORY_LIST_FAILD, error } }
}

function sendOrder(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        NewdanhmuckhohangService.sendOrder(payload).then((rs) => {
            dispatch(success(rs));
            alert("Đặt hàng thành công!");
        }).catch((error) => {
            dispatch(failure(error));
            alert("Không thể đặt sim này, có thể do hiện tại sim này đã bán. Bạn vui lòng chọn sim khác. Xin cảm ơn!");
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: NEWDANHMUCKHOHANG_ORDER_SUCCESS, data } }
    function failure(error) { return { type: NEWDANHMUCKHOHANG_ORDER_FAILD, error } }
}